import React, { createContext, useContext, useEffect, useState } from 'react'; // useState 임포트 추가
import { API_URL } from '../lib/config';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  // socketRef 대신 useState를 사용하여 소켓 인스턴스를 관리합니다.
  // 이렇게 하면 socket 상태가 업데이트될 때 Provider가 리렌더링되어 하위 컴포넌트에 새로운 값이 전달됩니다.
  const [socket, setSocket] = useState(null); // 초기 소켓 상태는 null

  useEffect(() => {
    // 소켓이 아직 생성되지 않았다면 새로 생성합니다.
    if (!socket) { // socket 상태가 null일 때만 실행
      if (process.env.NODE_ENV === 'development') {
        console.log('SocketContext: 새로운 소켓 인스턴스 생성 시도');
      }
      const newSocket = io(`${API_URL}`, {
        withCredentials: true,
        autoConnect: false,
        transports: ['websocket']
      });
      setSocket(newSocket); // 생성된 소켓을 상태로 저장 -> Provider가 리렌더링됨
      if (process.env.NODE_ENV === 'development') {
        console.log('Socket 인스턴스 초기 생성됨.');
      }

      // 이 부분은 newSocket이 생성된 직후에 실행되도록 합니다.
      newSocket.on('connect', () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('Socket connected:', newSocket.id);
        }
      });
      newSocket.on('disconnect', () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('Socket disconnected:', newSocket.id);
        }
      });
      newSocket.on('connect_error', (err) => {
        if (process.env.NODE_ENV === 'development') {
          console.error('SocketContext: 연결 오류:', err.message);
        }
      });

      // 여기서 바로 연결 시도
      if (!newSocket.connected) {
        newSocket.connect();
        if (process.env.NODE_ENV === 'development') {
          console.log('Socket 연결 시도.');
        }
      }

      // 클린업 함수에서 이벤트 리스너 제거
      return () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('SocketContext: 클린업. 리스너 제거.');
        }
        newSocket.off('connect');
        newSocket.off('disconnect');
        newSocket.off('connect_error');
        // socket.disconnect(); // 여전히 여기서 disconnect는 하지 않습니다.
      };
    }

    // 만약 소켓이 이미 생성되어 있다면 (즉, !socket 조건에 걸리지 않았다면)
    // 이 useEffect는 더 이상 실행되지 않습니다. (의존성 배열이 비어있으므로)
    // 이전에 생성된 소켓 인스턴스의 이벤트 리스너는 계속 활성화되어 있습니다.
    // 따라서 이 else 블록은 필요 없습니다.

  }, [socket]); // ★★★ 의존성 배열에 socket을 추가하여, socket 상태가 null -> 실제 소켓 인스턴스로 변경될 때 한 번 더 실행되도록 함

  return (
    // Provider의 value로 useState로 관리하는 'socket' 상태를 전달합니다.
    <SocketContext.Provider value={socket}> {/* ★★★ socket 상태를 value로 전달 */}
      {children}
    </SocketContext.Provider>
  );
};